import * as React from 'react'

import { Box } from '@factorialco/deprecated-design-system'

import type ReportStruct from 'modules/reports/lib/ReportStruct'

import * as styles from '../index.vanilla.css'
import Table from '../types/Table'

interface WrapperProps {
  data?: any
  reportStruct: ReportStruct
  hasTable: boolean
}

const Wrapper = ({
  data,
  reportStruct,
  hasTable,
  children,
}: React.PropsWithChildren<WrapperProps>) => {
  let chartWrapperClass
  switch (reportStruct.type) {
    case 'table':
      chartWrapperClass = styles.tableChartWrapper
      break
    case 'numeric_metric':
      chartWrapperClass = styles.numericMetricChartWrapper
      break
    default:
      chartWrapperClass = styles.defaultChartWrapper
      break
  }

  if (!data) return <>{children}</>

  return (
    <>
      <Box className={chartWrapperClass}>{children}</Box>
      {hasTable && <Table data={data} reportStruct={reportStruct} />}
    </>
  )
}

const TableWrapper = (props: React.PropsWithChildren<WrapperProps>) => {
  const { children } = props

  return <Wrapper {...props}>{children}</Wrapper>
}

export default TableWrapper
